/* eslint react-hooks/exhaustive-deps: "warn" */
import { useContext, useEffect, useRef } from 'react';

import { ContentContext } from 'context/ContentContext';

export const StaticPage = () => {
  const { data } = useContext(ContentContext);
  const content = (data as any).staticPageContent as string | undefined;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !content) return;

    const injected: HTMLScriptElement[] = [];

    if (!(window as any).__staticPageInitialized) {
      // On SPA navigation, browsers do not execute <script> tags injected via innerHTML
      // (dangerouslySetInnerHTML). Re-create and append them to trigger execution.
      // On SSR/hard reload the scripts already ran, so we skip re-execution.
      container.querySelectorAll<HTMLScriptElement>('script').forEach((oldScript) => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        newScript.textContent = `(function(){\n${oldScript.textContent}\n})();`;
        document.body.appendChild(newScript);
        injected.push(newScript);
      });
    }

    return () => {
      // Disconnect any IntersectionObservers registered by the static page scripts
      (window as any).__staticPageCleanup?.();
      (window as any).__staticPageCleanup = undefined;
      (window as any).__staticPageInitialized = false;
      injected.forEach((s) => s.remove());
    };
  }, [content]);

  if (!content) {
    return null;
  }

  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: content }} />;
};
